import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/CrtReports';

const CtrReportsPage = () => {
  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default CtrReportsPage;
